import _ from 'lodash'
// ==== action types ====

export const EDIT_TOTAL_PREMIUM = 'EDIT_TOTAL_PREMIUM'

export const UPDATE_TOTAL_PREMIUM = 'UPDATE_TOTAL_PREMIUM'

export const UPDATE_SELECTED_PLAN = 'UPDATE_SELECTED_PLAN'

export const UPDATE_RIDER_STATE = 'UPDATE_RIDER_STATE'

export const UPDATE_SELECT_BASIC_PLAN = 'UPDATE_SELECT_BASIC_PLAN'

export const UPDATE_TOTAL_RIDER_PREMIUM = 'UPDATE_TOTAL_RIDER_PREMIUM'

export const TOGGLE_RIDER = 'TOGGLE_RIDER'

export const TOGGLE_RIDER_MODULE = 'TOGGLE_RIDER_MODULE'

export const TOGGLE_RIDER_GROUP_MODULE = 'TOGGLE_RIDER_GROUP_MODULE'

export const UPDATE_AVAILABLE_RIDERS = 'UPDATE_AVAILABLE_RIDERS'

export const UPDATE_RIDERS_BENEFITS = 'UPDATE_RIDERS_BENEFITS'

export const SELECT_MODEL_FACTOR = 'SELECT_MODEL_FACTOR'

export const PATCH_MODEL_FACTOR = 'PATCH_MODEL_FACTOR'

export const EDIT_SUM_ASSURED = 'EDIT_SUM_ASSURED'

export const EDIT_LOAN_AMOUNT = 'EDIT_LOAN_AMOUNT'

export const UPDATE_SUM_ASSURED$ = 'UPDATE_SUM_ASSURED$'

export const EDIT_BASIC_PREMIUM = 'EDIT_BASIC_PREMIUM'

export const EDIT_BASIC_PREMIUM_STATE = 'EDIT_BASIC_PREMIUM_STATE'

export const UPDATE_BASIC_PREMIUM_STATE = 'UPDATE_BASIC_PREMIUM_STATE'

export const EDIT_PENSION_TYPE_STATE = 'EDIT_PENSION_TYPE_STATE'

export const EDIT_PENSION_AGE_BUMNAN_SMART = 'EDIT_PENSION_AGE_BUMNAN_SMART'

export const EDIT_PENSION_AGE_KOOMVER_RETIRE = 'EDIT_PENSION_AGE_KOOMVER_RETIRE'

export const UPDATE_BASIC_PREMIUM = 'UPDATE_BASIC_PREMIUM'
export const UPDATE_FULL_BASIC_PREMIUM = 'UPDATE_FULL_BASIC_PREMIUM'

export const UPDATE_FULL_ANNUAL_BASIC_PREMIUM = 'UPDATE_FULL_ANNUAL_BASIC_PREMIUM'

export const UPDATE_CAMPAIGN_DISCOUNT_MESSAGE = 'UPDATE_CAMPAIGN_DISCOUNT_MESSAGE'

export const UPDATE_CAMPAIGN_DISCOUNT_ENDDATE = 'UPDATE_CAMPAIGN_DISCOUNT_ENDDATE'

export const SET_MODEL_FACTORS = 'SET_MODEL_FACTORS'

export const EDIT_RIDER_SUM_ASSURED = 'EDIT_RIDER_SUM_ASSURED'

export const EDIT_RIDER_SELECTED_PLAN = 'EDIT_RIDER_SELECTED_PLAN'

export const EDIT_REVALIDATE_RIDER_SELECTED_PLAN = 'EDIT_REVALIDATE_RIDER_SELECTED_PLAN'

export const EDIT_RIDER_SELECTED_PLANGROUP = 'EDIT_RIDER_SELECTED_PLANGROUP'

export const EDIT_RIDER_PREMIUM = 'EDIT_RIDER_PREMIUM'

export const EDIT_RIDER_MODULE_PREMIUM = 'EDIT_RIDER_MODULE_PREMIUM'

export const UPDATE_OCCUPATION_FACTOR = 'UPDATE_OCCUPATION_FACTOR'

// ==== action creators ====
export const updateTotalPremium = (totalPremium) => ({
  type: UPDATE_TOTAL_PREMIUM,
  payload: totalPremium,
})

export const updateTotalRiderPremium = (totalRiderPremium) => ({
  type: UPDATE_TOTAL_RIDER_PREMIUM,
  payload: totalRiderPremium,
})

export const editTotalPremium = (totalPremium) => ({
  type: EDIT_TOTAL_PREMIUM,
  payload: _.toFinite(totalPremium),
})

export const toggleRider = (code, newState) => ({
  type: TOGGLE_RIDER,
  payload: { riderCode: code, newState },
})

export const toggleRiderModule = (riderCode, riderModuleCode, newState) => ({
  type: TOGGLE_RIDER_MODULE,
  payload: { riderCode, riderModuleCode, newState },
})

export const toggleRiderGroupModule = (riderCode, riderModuleGroupCode, newState) => ({
  type: TOGGLE_RIDER_GROUP_MODULE,
  payload: { riderCode, riderModuleGroupCode, newState },
})

export const updateAvailableRiders = (riders) => ({
  type: UPDATE_AVAILABLE_RIDERS,
  payload: riders,
})

export const updateRidersBenefits = (riders) => ({
  type: UPDATE_RIDERS_BENEFITS,
  payload: riders,
})

export const updateSelectedPlan = (selectedPlan) => ({
  type: UPDATE_SELECTED_PLAN,
  payload: selectedPlan,
})

export const updateSelectBasicPlan = (selectedPlan) => ({
  type: UPDATE_SELECT_BASIC_PLAN,
  payload: selectedPlan,
})

export const updateRiderState = (riderCode, props) => ({
  type: UPDATE_RIDER_STATE,
  payload: { riderCode, props },
})

export const editRiderSumAssured = (code, sumAssured) => ({
  type: EDIT_RIDER_SUM_ASSURED,
  payload: { code, sumAssured },
})

export const editRiderSelectedPlan = (code, selectedPlan) => ({
  type: EDIT_RIDER_SELECTED_PLAN,
  payload: { code, selectedPlan },
})
export const editRevalidateRiderSelectedPlan = (code, selectedPlan) => ({
  type: EDIT_REVALIDATE_RIDER_SELECTED_PLAN,
  payload: { code, selectedPlan },
})
export const editRiderSelectedPlanGroup = (code, selectedPlanGroup) => ({
  type: EDIT_RIDER_SELECTED_PLANGROUP,
  payload: { code, selectedPlanGroup },
})

export const editRiderPremium = (code, premium) => ({
  type: EDIT_RIDER_PREMIUM,
  payload: { code, premium },
})
export const editRiderModulePremium = (riderCode, riderModuleCode, premium) => ({
  type: EDIT_RIDER_MODULE_PREMIUM,
  payload: { riderCode, riderModuleCode, premium },
})
export const selectModelFactor = (modelFactorID) => ({
  type: SELECT_MODEL_FACTOR,
  payload: modelFactorID,
})
export const patchModelFactor = (modelFactorID) => ({
  type: PATCH_MODEL_FACTOR,
  payload: modelFactorID,
})

export const editSumAssured = (sumAssured) => ({
  type: EDIT_SUM_ASSURED,
  payload: _.toFinite(sumAssured),
})

export const editLoanAmount = (loanAmount) => ({
  type: EDIT_LOAN_AMOUNT,
  payload: _.toFinite(loanAmount),
})

export const updateSumAssured = (sumAssured) => ({
  type: UPDATE_SUM_ASSURED$,
  payload: sumAssured,
})

export const editBasicPremium = (basicPremium) => ({
  type: EDIT_BASIC_PREMIUM,
  payload: _.toFinite(basicPremium),
})

export const editBasicPremiumState = (basicPremium) => ({
  type: EDIT_BASIC_PREMIUM_STATE,
  payload: _.toFinite(basicPremium),
})

export const updateBasicPremiumState = (basicPremium) => ({
  type: UPDATE_BASIC_PREMIUM_STATE,
  payload: _.toFinite(basicPremium),
})

export const editPensionType = (pensionType) => ({
  type: EDIT_PENSION_TYPE_STATE,
  payload: pensionType,
})

export const editPensionAgeBumnanSmart = (pensionAge) => ({
  type: EDIT_PENSION_AGE_BUMNAN_SMART,
  payload: pensionAge,
})

export const editPensionAgeKoomverRetire = (pensionAge) => ({
  type: EDIT_PENSION_AGE_KOOMVER_RETIRE,
  payload: pensionAge,
})

export const updateBasicPremium = (basicPremium) => ({
  type: UPDATE_BASIC_PREMIUM,
  payload: _.toFinite(basicPremium),
})

export const updateFullBasicPremium = (fullBasicPremium) => ({
  type: UPDATE_FULL_BASIC_PREMIUM,
  payload: _.toFinite(fullBasicPremium),
})

export const updatFullAnnualBasicPremium = (fullAnnualBasicPremium) => ({
  type: UPDATE_FULL_ANNUAL_BASIC_PREMIUM,
  payload: _.toFinite(fullAnnualBasicPremium),
})

export const updateCampaignDiscountMessage = (campaignDiscountMessage) => ({
  type: UPDATE_CAMPAIGN_DISCOUNT_MESSAGE,
  payload: campaignDiscountMessage,
})

export const updateCampaignDiscountEndDate = (campaignDiscountEndDate) => ({
  type: UPDATE_CAMPAIGN_DISCOUNT_ENDDATE,
  payload: campaignDiscountEndDate,
})

export const setModelFactors = (modelFactors) => ({
  type: SET_MODEL_FACTORS,
  payload: modelFactors,
})

export const UPDATE_BASIC_PLAN_ERROR_MESSAGE = 'UPDATE_BASIC_PLAN_ERROR_MESSAGE'
export const updateBasicPlanErrorMessage = (errorMessage) => ({
  type: UPDATE_BASIC_PLAN_ERROR_MESSAGE,
  payload: errorMessage,
})

export const updateOccupationFactor = (occupationFactor) => ({
  type: UPDATE_OCCUPATION_FACTOR,
  payload: occupationFactor,
})
